import script from "./EditMeeting.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMeeting.vue?vue&type=script&setup=true&lang=js"

import "./EditMeeting.vue?vue&type=style&index=0&id=35d2ab66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d2ab66"]])

export default __exports__